/* eslint-disable react/no-unstable-nested-components */
import ContainedButton from "components/layout/form/containedButton";
import React, { useCallback, useState } from "react";
import TextField from "components/layout/form/textField";
import { FaRegUser } from "react-icons/fa";
import { Field, Formik } from "formik";
import { applyCpfCnpjInputMask } from "utils/validation/cpfCnpjLoginField";
import {
  isDocumentLengthInvalid,
  normalizeDocumentForPayload,
  sanitizeDocument,
} from "utils/formatting/document";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { validateCNPJ, validateCPF } from "utils/functions";
import { useQuickBillContext } from "features/boleto-rapido/hooks/useQuickBill";

import { useGaEvents } from "features/boleto-rapido/hooks/useGaEvents";

import {
  Container,
  ContainerButtons,
  FormContainer,
  Subtitle,
  TextWrapper,
  Title,
  Wrapper,
} from "./styles";

const FormBoletoRapido: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [dispatchErrorCpf, setDispatchErrorCpf] = useState(false);

  const { handleClickDocument, documentInvalid } = useGaEvents();

  const history = useHistory();

  const { setDocument, setStep, handleClearData } = useQuickBillContext();

  const validateDocument = (value: string): string | undefined => {
    const s = sanitizeDocument(value || "");
    if (!s) {
      return "É obrigatório preencher seus dados!";
    }
    if (isDocumentLengthInvalid(value || "")) {
      return "Documento inválido";
    }
    if (s.length === 11 && /^\d{11}$/.test(s) && !validateCPF(s)) {
      return "Insira um CPF válido";
    }
    if (s.length === 14 && !validateCNPJ(s)) {
      return "Insira um CNPJ válido";
    }
    return undefined;
  };

  const handleDocument = useCallback((event, handleChange) => {
    applyCpfCnpjInputMask(event);
    handleChange(event);
  }, []);

  const handleSubmit = useCallback(
    async ({ document }) => {
      handleClickDocument(document);
      setLoading(true);
      const numbers = normalizeDocumentForPayload(document);
      handleClearData();
      setDocument(numbers);
      setStep(2);
      history.push("/boleto-rapido");
    },
    [setLoading]
  );

  return (
    <Wrapper>
      <Container>
        <TextWrapper>
          <Title>Boleto Rápido</Title>
          <Subtitle>Veja seus boletos de maneira rápida e eficiente.</Subtitle>
        </TextWrapper>
        <Formik
          initialValues={{
            document: "",
          }}
          onSubmit={handleSubmit}
          render={({ handleChange, handleBlur, values, errors, touched }) => {
            if (
              errors.document &&
              touched.document &&
              !dispatchErrorCpf &&
              (errors?.document === "Insira um CNPJ válido" ||
                errors?.document === "Documento inválido" ||
                errors?.document === "Insira um CPF válido")
            ) {
              setDispatchErrorCpf(true);
              documentInvalid(
                values.document,
                (errors?.document as string) ?? ""
              );
            }
            return (
              <FormContainer>
                <Field
                  validate={validateDocument}
                  name="document"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      inputMode="text"
                      label="Insira seu CPF ou CNPJ *"
                      placeholder="Insira seu CPF ou CNPJ *"
                      errorCondition={errors.document && touched.document}
                      errorMessage={errors.document}
                      isCorrect={!errors.document}
                      value={values.document}
                      // @ts-ignore
                      LeadingIcon={() => <FaRegUser />}
                      onBlur={handleBlur}
                      onClick={() => toast.dismiss()}
                      onChange={(e) => {
                        setDispatchErrorCpf(false);
                        handleDocument(e, handleChange);
                      }}
                    />
                  )}
                />

                <ContainerButtons>
                  <ContainedButton
                    block
                    type="submit"
                    continue
                    loading={loading}
                    disabled={loading || !values.document}
                    id="Avançar"
                    width="100%"
                  >
                    2ª Via Boleto Rápido
                  </ContainedButton>
                </ContainerButtons>
              </FormContainer>
            );
          }}
        />
      </Container>
    </Wrapper>
  );
};

export default FormBoletoRapido;
